import { useTranslation } from "react-i18next";
import { UserStatus, DocumentVersionStatus } from "../config/types";
import { getDocumentVersionStatusLabel } from "~/helpers/document";

export const FieldStatus = ({
  status,
}: {
  status?: DocumentVersionStatus | UserStatus;
}) => {
  const { t } = useTranslation();

  const statusLabel: Record<DocumentVersionStatus | UserStatus, string> = {
    ...getDocumentVersionStatusLabel(t),
    [UserStatus.active]: t("commons.documentStatus.active"),
    [UserStatus.deactivated]: t("commons.documentStatus.deactivated"),
    [UserStatus.pending]: t("commons.documentStatus.pending"),
    [UserStatus.deleted]: t("commons.deleted"),
  };

  if (!status) {
    return null;
  }

  const colorStyle = (): React.CSSProperties => {
    switch (status) {
      case DocumentVersionStatus.draft:
        return {
          color: "#344054",
          background: "#E4E7EC",
        };
      case DocumentVersionStatus.archived:
        return {
          color: "#B42318",
          background: "#FEF3F2",
        };
      case DocumentVersionStatus.published:
        return {
          color: "#546554",
          background: "#DDE4DD",
        };
      case UserStatus.pending:
        return {
          color: "#B54708",
          background: "#FFFAEB",
        };
      case UserStatus.active:
        return {
          color: "#027A48",
          background: "#ECFDF3",
        };
      case UserStatus.deactivated:
        return {
          color: "#344054",
          background: "#F2F4F7",
        };
      default:
        return {
          color: "fff",
          background: "000",
        };
    }
  };

  return (
    <div
      className="w-min rounded-2xl px-2 py-1 text-xs font-medium whitespace-nowrap"
      style={colorStyle()}
    >
      {statusLabel[status]}
    </div>
  );
};
